import { Injector, inject } from "@angular/core";
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";
import { environment } from "src/environments/environment";
import { AppConstants } from "../app.constants";

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  if (message.endsWith("msal:acquireTokenFailure")) {
    try {
      const selectedTheme = localStorage.getItem(AppConstants.themeStorageKey);
      localStorage.clear();
      if (selectedTheme === AppConstants.lightTheme || selectedTheme === AppConstants.darkTheme) {
        localStorage.setItem(AppConstants.themeStorageKey, selectedTheme);
      } else {
        localStorage.setItem(AppConstants.themeStorageKey, AppConstants.defaultTheme);
      }
    } catch {
      // Ignore storage errors and continue redirect to re-initiate session.
    }
    window.location.assign(environment.sessionInitiatelURL);
  }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.client_Id, // "01a8800b-1663-41b7-b918-a3719152665d",
      authority: environment.authority, // "https://login.microsoftonline.com/ceb177bf-013b-49ab-8a9c-4abce32afc1e",
      redirectUri: environment.redirectUrl, // "https://localhost:4200/response-oidc",
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [environment.graphEndPoint, [environment.scopesUserRead]],
    ]),
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.scopesUserRead],
    },
  };
}
